import { render, staticRenderFns } from "./save-activity-goods.vue?vue&type=template&id=69fe7548&"
import script from "./save-activity-goods.vue?vue&type=script&lang=js&"
export * from "./save-activity-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports